import React, { useState, useEffect, Fragment } from "react";
import { TableComponent } from "./table/Table";
import { connect } from "react-redux";
import { Search } from "../../layout/Table/Search";
import { Paginator } from "../../layout/Paginator/Paginator";
import { getPackages as getPackagesApi } from "../../../api/clients/packages";
import { FiltersList } from "../../shared/filters/FiltersList";
import { useDidMountEffect } from '../../../helpers/useDidMountEffect';
import { ACL, PAGE_CONTEXTS, TABLE_CONTEXTS, TABLE_SEARCHES_TYPES } from '../../../config/constants';
import { store } from '../../../store/store';
import { hideNotification } from '../../../store/actions/notification';
import { RowsPerPage } from "../../layout/Table/RowsPerPage";
import { tablesSearches as tablesSearchesAction } from "../../../store/actions/user";
import { useDispatch, useSelector } from 'react-redux';
import { getTableSearches } from "../../../helpers/tables";
import { ListToolbar } from '../../layout/Workspace';
import { CheckboxFilter } from '../../shared/filters/CheckboxFilter';
import { SelectUserFilter } from '../../shared/filters/SelectUserFilter';
import { FILTERS, FILTERS_NAMES } from '../../../config/packageStatus';
import { TRANSLATED_PACKAGE_STATUSES } from '../../../config/constants';
import { FormattedMessage } from 'react-intl';

let oneTimeCall = false;
const DocumentsTableComponent = (props) => {
  const tablesSearches = getTableSearches(PAGE_CONTEXTS.DOCUMENTS.LIST, TABLE_CONTEXTS.DOCUMENTS);

  const [ sortDirection, setSortDirection ] = useState( tablesSearches.sortDirection );
  const [ sortField, setSortField ] = useState( tablesSearches.sortField );
  const [ searchText, setSearchText ] = useState( tablesSearches.searchText );
  const [ items, setItems ] = useState( null )
  const [ meta, setMeta ] = useState( tablesSearches.meta );
  const [ filters, setFilters ] = useState( tablesSearches.filters )
  const [ rowsPerPage, setRowsPerPage ] = useState( tablesSearches.rowsPerPage );
  const dispatch = useDispatch();
  const stateTablesSearches = useSelector( store => store.user.tablesSearches );

  useEffect( () => {
    getPackages( (meta && meta.current_page) ?? 1, sortField, sortDirection, searchText, filters );

    return () => {
      store.dispatch(hideNotification());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] )

  useEffect( () => {
    getPackages( 1, sortField, sortDirection, searchText, filters );

    return () => {
      store.dispatch(hideNotification());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage] );

  useDidMountEffect( () => {
    getPackages( 1, null, null, null, filters );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ filters ] )
  /**
   * Get client documents
   * @param {number} [page]
   * @param {string} [sortField]
   * @param {string} [sortDirection]
   * @param {string} [searchText]
   * @param {object} [filters]
   * @param {boolean} [hideNotification]
   */
  const getPackages = (page, sortField, sortDirection, searchText, filters, hideNotification = false) => {
    if (! ACL.CLIENT.DOCUMENTS.LIST.hasAccess() || oneTimeCall === true) {
      return;
    }

    oneTimeCall = true;
    getPackagesApi( {
      pagination: {
        page: page,
        sort_by: sortField,
        sort: sortDirection,
        q: searchText,
        per_page: rowsPerPage,
        statuses: filters?.byStatuses?.map( function (item) {
          return item.identifier
        } ),
        from_owners: filters?.byOwnerUsers?.map( function (item) {
          return item.identifier
        } ),
        page_context: props.pageContext,
      },
      hideNotification: hideNotification,
    } ).then( (response) => {
      if (! response || ! response.data) {
        return;
      }

      setItems( response.data );
      setMeta( response.meta );

      let newTablesSearches = stateTablesSearches ?? {};
      newTablesSearches[PAGE_CONTEXTS.DOCUMENTS.LIST] = {};
      newTablesSearches[PAGE_CONTEXTS.DOCUMENTS.LIST][TABLE_CONTEXTS.DOCUMENTS] = {};
      newTablesSearches[PAGE_CONTEXTS.DOCUMENTS.LIST][TABLE_CONTEXTS.DOCUMENTS][TABLE_SEARCHES_TYPES.SORT_FIELD] = sortField;
      newTablesSearches[PAGE_CONTEXTS.DOCUMENTS.LIST][TABLE_CONTEXTS.DOCUMENTS][TABLE_SEARCHES_TYPES.SORT_DIRECTION] = sortDirection;
      newTablesSearches[PAGE_CONTEXTS.DOCUMENTS.LIST][TABLE_CONTEXTS.DOCUMENTS][TABLE_SEARCHES_TYPES.SEARCH_TEXT] = searchText;
      newTablesSearches[PAGE_CONTEXTS.DOCUMENTS.LIST][TABLE_CONTEXTS.DOCUMENTS][TABLE_SEARCHES_TYPES.META] = response.meta;
      newTablesSearches[PAGE_CONTEXTS.DOCUMENTS.LIST][TABLE_CONTEXTS.DOCUMENTS][TABLE_SEARCHES_TYPES.FILTERS] = filters ?? { byStatuses: [], byOwnerUsers: [] };
      newTablesSearches[PAGE_CONTEXTS.DOCUMENTS.LIST][TABLE_CONTEXTS.DOCUMENTS][TABLE_SEARCHES_TYPES.ROWS_PER_PAGE] = rowsPerPage;

      dispatch( tablesSearchesAction(newTablesSearches) );
    } ).finally(() => {
      oneTimeCall = false;
    });
  };

  /**
   * Apply sort by appliedSortField
   * @param {string} appliedSortField
   */
  function applySort(appliedSortField) {
    let newSortDirection = "";

    if (sortField) {
      if (sortField === appliedSortField) {
        newSortDirection = sortDirection === "asc" ? "desc" : "asc";
      } else {
        newSortDirection = "asc";
      }
    } else {
      newSortDirection = "asc";
    }

    setSortField( appliedSortField );
    setSortDirection( newSortDirection );

    getPackages( meta.current_page, appliedSortField, newSortDirection, searchText, filters, true );
  }

  const applyFilters = (key, data) => {
    setFilters( {
      ...filters,
      [key]: data
    } );
  }

  const removeAllFilters = () => {
    setFilters( {
      byStatuses: [],
    } );
  }

  const removeFilter = item => {
    setFilters( {
      ...filters,
      [item.key]: filters[item.key].filter( elem => elem.identifier !== item.identifier )
    } );
  }

  return (
    <div className="documents-list-layout">
      <ListToolbar
        activeFilters={(
          <FiltersList
            id="filters"
            filters={filters}
            filterList="documents"
            onRemoveFilter={removeFilter}
            onRemoveAllFilters={removeAllFilters}
          />
        )}
        className="documents-list-toolbar"
        filters={(
          <Fragment>
            <div className="documents-list-filter">
              <span className="documents-list-filter__label">
                <FormattedMessage id="components.shared.filters.selectUserFilter.byOwnerUsers"/>
              </span>
              <SelectUserFilter
                index={0}
                applyFilters={applyFilters}
                filters={filters.byOwnerUsers}
                filterKey={FILTERS.byOwnerUsers}
                filterName={FILTERS_NAMES.byOwnerUsers}
                type="button"
              />
            </div>
            <div className="documents-list-filter">
              <span className="documents-list-filter__label">
                <FormattedMessage id="pages.packages.packageList.package_status"/>
              </span>
              <CheckboxFilter
                index={1}
                applyFilters={applyFilters}
                filters={filters.byStatuses}
                filterKey={FILTERS.byStatuses}
                filterName={FILTERS_NAMES.byStatuses}
                list={TRANSLATED_PACKAGE_STATUSES}
                type="button"
              />
            </div>
          </Fragment>
        )}
        search={ACL.CLIENT.DOCUMENTS.SEARCH.hasAccess() ? (
          <Search
            permissions
            search={(searchText) => {
              setSearchText( searchText );
              getPackages( 1, null, null, searchText, filters, true );
            }}
            id="client-documents"
            searchText={searchText}
          />
        ) : null}
      />
      <div className="documents-list-table">
        <TableComponent
          applySort={(sortField) => applySort( sortField )}
          items={items}
          actionCallback={(useState) => {
            if (useState) {
              getPackages( meta.current_page, sortField, sortDirection, searchText, filters );
            } else {
              getPackages();
            }
          }}
        />
      </div>
      <div className="documents-list-pagination">
        <Paginator
          meta={meta}
          settings={(
            <RowsPerPage
              changeRowsPerPage={(rowsPerPage) => {
                setRowsPerPage(rowsPerPage);
              }}
              id="client-documents"
              rowsPerPage={rowsPerPage}
            />
          )}
          changePage={(page) =>
            getPackages( page, sortField, sortDirection, searchText, filters, true )
          }
        />
      </div>
    </div>
  )
}

DocumentsTableComponent.defaultProps = {};

const DocumentsTable = connect( null, {} )( DocumentsTableComponent );

export { DocumentsTable, DocumentsTableComponent };
